import { createEntityAdapter, EntityState, Update } from "@ngrx/entity";
import { GrantedAccessModel } from "../../models/granted-access-model";
import { createFeature, createReducer, on } from "@ngrx/store";
import { GrantedAccessSchemaV2Actions } from "./granted-access-schema-v2.actions";

export const GRANTED_ACCESS_SCHEMA_V2_FEATURE_KEY = 'GrantedAccessSchemaV2';

export interface GrantedAccessSchemaV2State extends EntityState<GrantedAccessModel.GrantedAccessDocument> {
    isLoading: boolean;
}

export const grantedAccessSchemaV2Adapter = createEntityAdapter<GrantedAccessModel.GrantedAccessDocument>({
    selectId: (item) => item._id,
});

export const initialState: GrantedAccessSchemaV2State = grantedAccessSchemaV2Adapter.getInitialState({
    isLoading: false,
});

export const grantedAccessSchemaV2StateReducer = createReducer(
    initialState,
    on(GrantedAccessSchemaV2Actions.loadGrantedAccessSchemaV2,
        state => ({
            ...state,
            isLoading: true,
        }),
    ),
    on(GrantedAccessSchemaV2Actions.loadGrantedAccessSchemaV2Success,
        (state, { grantedAccessList }) =>
            grantedAccessSchemaV2Adapter.setAll(grantedAccessList, {
                ...state,
                isLoading: false,
            }),
    ),
    on(GrantedAccessSchemaV2Actions.loadGrantedAccessSchemaV2Fail,
        state => ({
            ...state,
            isLoading: false,
        }),
    ),
    on(GrantedAccessSchemaV2Actions.revokeAccessSuccess, (state, { grantedAccess }) => {
        const update: Update<GrantedAccessModel.GrantedAccessDocument> = {
            id: grantedAccess._id,
            changes: {
                ...grantedAccess,
            },
        };
        return grantedAccessSchemaV2Adapter.updateOne(update, state);
    }),
);

export const grantedAccessSchemaV2Feature = createFeature({
    name: GRANTED_ACCESS_SCHEMA_V2_FEATURE_KEY,
    reducer: grantedAccessSchemaV2StateReducer,
    extraSelectors: ({ selectGrantedAccessSchemaV2State }) => {
        const {
            selectAll,
            selectEntities,
            selectIds,
            selectTotal,
        } = grantedAccessSchemaV2Adapter.getSelectors(
            selectGrantedAccessSchemaV2State,
        );

        return {
            selectAll,
            selectEntities,
            selectIds,
            selectTotal,
        };
    },
});